import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/auth/auth.service';
import { InputGeneralApplicationComponent } from 'app/modules/landing/corporate/input-general-application/input-general-application.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-verify-dialog',
    templateUrl: './verify-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        InputGeneralApplicationComponent,
        ReactiveFormsModule,
    ],
})
export class VerifyDialogComponent {
    // Class variables
    disableVerifyBtn = true;
    mailSent = true;
    submitted: boolean = false;
    varifyMobile = this.fb.group({
        otp: [
            '',
            [
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(6),
            ],
        ],
    });

    // Timer variablesyes
    minutes: number = 1;
    seconds: number = 0;
    timer: any;
    VerifyMobileNoError: string;
    VerifyDigitMobileNoError: string;
    resendBtn = false;
    closeTostr: string;
    ClientTranKey: string;
    referenceId: string;

    // Initialize the component
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<VerifyDialogComponent>,
        private translate: TranslateService,
        private fb: FormBuilder,
        private authService: AuthService,
        private toastr: ToastrService,
    ) {
        this.ClientTranKey = data.clientTranKey;
        this.referenceId = data.referenceid;
    }

    ngOnInit() {
        this.startTimer();
        this.translate.get('ERROR.INVALID_OTP').subscribe((data: any) => {
            this.VerifyMobileNoError = data;
        });
        this.translate.get('ERROR.OTP_LENGTH').subscribe((data: any) => {
            this.VerifyDigitMobileNoError = data;
        });
        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });
    }

    // Close the dialog on click cross button
    onDialogClose(result: boolean): void {
        this.dialogRef.close();
    }

    // Timer function
    startTimer() {
        this.timer = setInterval(() => {
            if (this.seconds > 0) {
                this.seconds--;
            } else if (this.minutes > 0) {
                this.minutes--;
                this.seconds = 59;
            } else {
                clearInterval(this.timer);
                this.resendBtn = true;
            }
        }, 1000);
    }

    // Verify OTP on form submit
    onFormSubmit(event, data) {
        this.submitted = true;
        if (this.varifyMobile.valid) {
            let reqData = {
                pincode: data.otp,
                clientTranKey: this.ClientTranKey,
                referenceid: this.referenceId,
            };
            this.authService.verifySmsOTP(reqData).subscribe({
                next: (response) => {
                    this.dialogRef.close(true);
                },
                error: (err) => {
                    // TBD

                    // the error message only when otp is invalid
                    const currentErrors =
                        this.varifyMobile.get('otp').errors || {};
                    this.varifyMobile
                        .get('otp')
                        .setErrors({ ...currentErrors, invalidOTP: true });
                    if (this.varifyMobile.invalid) {
                        return;
                    }
                    // the error message only when otp is invalid
                },
            });
        }
    }

    // Get errors for input field
    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];
        if (this.submitted) {
            if (
                input == 'otp' &&
                this.varifyMobile.get('otp')?.errors?.required
            ) {
                errors.push(inputName);
            } else if (
                (input == 'otp' &&
                    this.varifyMobile.get('otp')?.errors?.minlength) ||
                this.varifyMobile.get('otp')?.errors?.maxlength
            ) {
                errors.push(this.VerifyDigitMobileNoError);
            } else if (
                input == 'otp' &&
                this.varifyMobile.get('otp')?.errors?.invalidOTP
            ) {
                errors.push(this.VerifyMobileNoError);
            }
        }
        return errors;
    }

    // Allow only numbers in input field
    keyPressNumbers(event: any) {
        const inputValue = event.target.value;

        if (inputValue.length > 6) {
            event.target.value = inputValue.slice(0, 6);
            this.varifyMobile.get('otp').setErrors({
                minlength: false,
                maxlength: false,
                required: false,
            });
        } else {
            let numericValue = '';
            numericValue = inputValue.replace(/[^0-9]/g, '');
            numericValue = numericValue === '' ? null : numericValue;
            event.target.value = numericValue;
        }
        if (event.target.value.length === 6) {
            this.disableVerifyBtn = false;
        } else {
            this.disableVerifyBtn = true;
        }
    }

    // Allow only numbers in paste
    pasteNumberOnly(event) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text');

        if (isNaN(pastedData)) {
            event.preventDefault();
        } else {
            return;
        }
    }

    // Resend OTP start
    resendOtp() {
        let reqData = {};
        this.authService.generateSmsOTP(reqData).subscribe({
            next: (response) => {
                this.varifyMobile.reset();
                this.submitted = false;
                this.ClientTranKey = JSON.parse(response).client_Trans_Id;
                this.referenceId = JSON.parse(response).reference_Id;
                this.minutes = 1;
                this.seconds = 0;
                this.startTimer();
                this.resendBtn = false;
                this.disableVerifyBtn = true;
            },
            error: (err) => {
                this.toastr.error(err.message);
            },
        });
    }
    // Resend OTP end
}
